import { checkCart } from "../helpers";
import { gsap } from "gsap";

export default class ProductForm extends HTMLElement {

	constructor(){

		super();

		this.form = this.querySelector("form");
		this.submitBtn = this.form.querySelector("[type='submit']");
		if (!this.submitBtn) return;
		this.submitBtnHtml = this.submitBtn.innerHTML;
		this.variant = this.form.querySelector("[name='id']");
		this.processing = false;
		this.processingHtml = `<span style="opacity:0;">Processing ...</span>`;
		this.cartNotification = document.querySelector("cart-notification");

		this.productData = (this.form.querySelector("[name='data']")) ? JSON.parse(this.form.querySelector("[name='data']").value) : {};
		this.variantData = (this.form.querySelector("[name='variants']")) ? JSON.parse(this.form.querySelector("[name='variants']").value) : {};
		this.optionData = (this.form.querySelector("[name='options']")) ? JSON.parse(this.form.querySelector("[name='options']").value) : {};

		/** Bind our form */
		this.variant.disabled = false;
		this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

		/* Limit add to cart off quantity */
		this.addCount = 0;
		this.addLimit = this.dataset.addLimit || false;
	}

	/**
	 * Add to cart form submission
	 * @param {Object} event
	 * @returns
	 */
	onSubmitHandler(event){

		event.preventDefault();

		if(this.processing === true) return;

		this.handleErrorMessage();

		/** Focus cart notification */
		// if(this.cartNotification) this.cartNotification.setActiveElement(document.activeElement);

		/** Block multiple requests */
		this.submitBtn.setAttribute("aria-disabled", true);
		this.processing = true;
		this.runProcessingAnimation(true);

		/** Grab form data */
		const formData = new FormData(this.form);

		// if(this.cartNotification) formData.append("sections", this.cartNotification.getSectionsToRender().map((section) => section.id));

		formData.append("sections_url", window.location.pathname);

		/** Safari fallback */
		if(!formData.get("quantity") && this.form.querySelector("[name='quantity']")){
			formData.append("quantity", this.form.querySelector("[name='quantity']").value);
		}

		/** Submit product form */
		fetch(this.form.action, {
			method: "POST",
			headers: {
				"X-Requested-With": "XMLHttpRequest",
				"Accept": "application/json"
			},
			body: formData
		})
		.then(response => response.json())
		.then(response => {

			if(response.status){

				this.handleErrorMessage(response.description);

				return;
			}

			// if(this.cartNotification) this.cartNotification.renderContents(response);

			checkCart();

			return response;
		})
		.catch((e) => {
			console.error(e);
		})
		.finally((res) => {
			this.submitBtn.removeAttribute("aria-disabled");
			this.processing = false;
			this.runProcessingAnimation();

			if (this.addLimit) {
				this.addCount++;
				if (this.addCount >= this.addLimit) {
					this.submitBtn.setAttribute("aria-disabled", true);
					this.submitBtn.setAttribute("disabled", true);
				}
			}
		});
	}
	/**
	 * Add to cart form submission
	 * @param {element} errorMessage
	 * @returns
	 */
	handleErrorMessage(errorMessage = false){

		this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".error-message-wrapper");
		this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".error-message");

		this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

		if(errorMessage) this.errorMessage.textContent = errorMessage;
	}

	/**
	 * Add to cart feedback event
	 * @param {boolean} run
	 * @returns
	 */
	runProcessingAnimation(run = false){

		if(!run){

			gsap.to(this.submitBtn.children, { opacity: 0, duration: 0.1, onComplete: ()=>{
				this.submitBtn.innerHTML = this.submitBtnHtml;
				gsap.set(this.submitBtn.children, { opacity: 0 });
				gsap.to(this.submitBtn.children, { opacity: 1, duration: 0.1 });
			}});

			return;
		}

		gsap.to(this.submitBtn.children, { opacity: 0, duration: 0.1, onComplete: ()=>{
			this.submitBtn.innerHTML = this.processingHtml;
			gsap.to(this.submitBtn.children, { opacity: 1, duration: 0.1 });
		}});
	}
}
